import { BaseTextMergeContainerElement } from "./BaseTextMergeContainerElement";
import { TextMergeConfiguration } from "../TextMergeConfiguration";
import { IConfigStorage } from "../../Common/IConfigStorage";
import { DataUtilities } from "../../Common/DataUtilities";
import { DataDefinition } from "../../Common/Data/DataDefinition";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../Common/Testing/ITestingContext";

export abstract class BaseTextMergeElement implements IConfigStorage {
    abstract readonly __type: string;
    abstract readonly name: string;
    abstract readonly ordinal: number;
    id: string = DataUtilities.generateUniqueId();

    parent?: BaseTextMergeContainerElement;

    abstract output(
        data: ExecutionData,
        config: TextMergeConfiguration,
        testContext: ITestingContext | undefined
    ): string;

    abstract canAdd(config: TextMergeConfiguration): boolean;

    getStorageData(): object {
        let d = { id: this.id, __type: this.__type };

        return d;
    }

    setStorageData(d: object): void {
        this.id = Reflect.get(d, "id");
    }

    // allows stuff to be done when we move off an element
    onDeselect() {}

    getInputData(): DataDefinition {
        return this.parent!.getInputData();
    }

    getDepth() {
        let i = 0;

        let current = this.parent;

        while (current) {
            i = i + 1;
            current = current.parent;
        }

        return i;
    }
}
